import React from "react";
import {
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Progress,
    Spinner,
} from "reactstrap";

const ReviewWizardModal = ({
    isOpen,
    onClose,
    title,
    activeStepAssetRemark,
    isLoading = false,
    steps = [],
    activeIndex = 0,
    setActiveIndex,
    progressWidth = 0,
    renderStepContent,
    isFirstStep = false,
    hideNextButton = false,
    nextButtonLabel = "Next",
    onBack,
    onNext,
    backDisabled = false,
    nextDisabled = false,
}) => (
    <Modal
        isOpen={isOpen}
        toggle={onClose}
        size="xl"
        modalClassName="asset-review-modal"
        scrollable
        backdrop="static"
    >
        <ModalHeader toggle={onClose}>
            {title}
        </ModalHeader>
        <ModalBody>
            {activeStepAssetRemark ? (
                <div className="alert alert-warning mb-3" role="alert">
                    <strong>Review not completed remark:</strong> {activeStepAssetRemark}
                </div>
            ) : null}
            {isLoading ? (
                <div className="text-center py-5">
                    <Spinner color="primary" />
                </div>
            ) : !steps.length ? (
                <p className="text-muted mb-0">No review data found.</p>
            ) : (
                <div className="card">
                    <div className="card-body">
                        <div className="twitter-bs-wizard">
                            <ul className="twitter-bs-wizard-nav nav-justified nav nav-pills" role="tablist">
                                {steps.map((step, index) => (
                                    <li className="nav-item" role="presentation" key={step.key}>
                                        <button
                                            type="button"
                                            className={`nav-link ${activeIndex === index ? "active" : ""}`}
                                            onClick={() => setActiveIndex(index)}
                                            role="tab"
                                        >
                                            <span className="step-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </span>
                                            <span className="step-title">{step.title}</span>
                                        </button>
                                    </li>
                                ))}
                            </ul>

                            <Progress className="mt-4" value={progressWidth} color="success" striped animated />

                            <div className="tab-content twitter-bs-wizard-tab-content">
                                {steps.map((step, index) => (
                                    <div
                                        key={step.key}
                                        className={`tab-pane ${index === activeIndex ? "active show" : ""}`}
                                        role="tabpanel"
                                    >
                                        {renderStepContent(step)}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </ModalBody>
        <ModalFooter className="d-flex justify-content-between">
            <Button
                color="secondary"
                size="sm"
                onClick={onBack}
                disabled={isFirstStep || backDisabled}
            >
                Back
            </Button>
            {!hideNextButton ? (
                <Button
                    color="primary"
                    size="sm"
                    onClick={onNext}
                    disabled={nextDisabled}
                >
                    {nextButtonLabel}
                </Button>
            ) : (
                <span />
            )}
        </ModalFooter>
    </Modal>
);

export default ReviewWizardModal;
